import $ from 'jquery';
import './search.scss';
import Sloth from '../Sloth';

@Sloth.component({})

export default class Search {
    onInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./components/Search/search.js
 **/